import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import invoiceService from "./invoiceService";

const initialState = {
  viewinvoices: [],
  invoicedatas: [],
  monthlyallinvoices: [],
  collectionInfo: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const getViewInvoice = createAsyncThunk(
  "viewInvoice/get-viewInvoice",
  async (id, thunkAPI) => {
    try {
      return await invoiceService.getViewInvoice(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getInvoiceData = createAsyncThunk(
  "invoiceData/get-invoiceData",
  async (id, thunkAPI) => {
    try {
      return await invoiceService.getInvoiceData(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const deleteInvoice = createAsyncThunk(
  "invoice/delete-invoice",
  async (invoiceData, thunkAPI) => {
    try {
      return await invoiceService.deleteInvoice(invoiceData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createInvoice = createAsyncThunk(
  "invoiceData/create-invoice",
  async (invoicedata, thunkAPI) => {
    try {
      return await invoiceService.createInvoices(invoicedata);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getMonthlyAllInvoice = createAsyncThunk(
  "monthlyAllInvoice/get-monthlyAllInvoice",
  async (id, thunkAPI) => {
    try {
      return await invoiceService.getMonthlyAllInvoice(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCollectionInfo = createAsyncThunk(
  "collectionInfo/get-collectionInfo",
  async (filters, thunkAPI) => {
    try {
      return await invoiceService.getCollectionInfo(filters);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCollectionInfoForVc = createAsyncThunk(
  "collectionInfo/get-collectionInfoforvc",
  async (filters, thunkAPI) => {
    try {
      return await invoiceService.getCollectionInfoForVc(filters);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    resetInvoiceState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getViewInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getViewInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.viewinvoices = action.payload;
      })
      .addCase(getViewInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getInvoiceData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvoiceData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.invoicedatas = action.payload;
      })
      .addCase(getInvoiceData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getMonthlyAllInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMonthlyAllInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.monthlyallinvoices = action.payload;
      })
      .addCase(getMonthlyAllInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdPayment = action.payload;
        // Optionally append the new invoice to invoicedatas
        if (action.payload?.data?.invoice) {
          state.invoicedatas = {
            ...state.invoicedatas,
            data: {
              ...state.invoicedatas.data,
              invoices: [
                ...(state.invoicedatas.data?.invoices || []),
                action.payload.data.invoice,
              ],
            },
          };
        }
      })
      .addCase(createInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        // Remove the deleted invoice from invoicedatas
        if (action.payload?.data?.invoice_no) {
          state.invoicedatas = {
            ...state.invoicedatas,
            data: {
              ...state.invoicedatas.data,
              invoices: state.invoicedatas.data?.invoices.filter(
                (invoice) =>
                  invoice.invoice_no !== action.payload.data.invoice_no
              ),
            },
          };
        }
      })
      .addCase(deleteInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(getCollectionInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCollectionInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.collectionInfo = action.payload.states || [];
      })
      .addCase(getCollectionInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getCollectionInfoForVc.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCollectionInfoForVc.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.collectionInfo = action.payload.states || [];
      })
      .addCase(getCollectionInfoForVc.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export const { resetInvoiceState } = invoiceSlice.actions;
export default invoiceSlice.reducer;
